import { useTranslation } from 'react-i18next';

export default function ProjetsRecents() {
  const { t } = useTranslation('stjean');

  const projets = [
    {
      title: t('projet_1_title'),
      desc: t('projet_1_desc'),
      img: "https://readdy.ai/api/search-image?query=Modern family cottage house in Quebec with new architectural asphalt shingle roof, suburban residential street, well-kept garden, bright daylight, authentic residential photography, warm earth tones with slate blue sky and copper accents on roof vents, family home style"
      ,
      alt: "toiture cottage Saint-Jean-Chrysostome Président-Kennedy",
    },
    {
      title: t('projet_2_title'),
      desc: t('projet_2_desc'),
      img: "https://readdy.ai/api/search-image?query=Historic village house in Quebec with restored roofing work in progress, traditional architecture, old village street setting, warm afternoon light, authentic heritage restoration photography, earthy tones with slate blue sky and copper roof details"
      ,
      alt: "restauration toiture ancienne rue Principale Saint-Jean-Chrysostome",
    },
    {
      title: t('projet_3_title'),
      desc: t('projet_3_desc'),
      img: "https://readdy.ai/api/search-image?query=Converted old farmhouse in Quebec countryside with new metal standing seam roof, rural property with large lot, open fields, bright daylight, authentic farm conversion photography, warm earth tones with slate blue distant horizon and copper roof accents"
      ,
      alt: "conversion tôle fermette Chemin Olivier Saint-Jean-Chrysostome",
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-8 md:mb-10 text-center">
          {t('projets_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {projets.map((p, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg border border-gray-100 overflow-hidden hover:border-[#C77D3F]/30 transition-colors"
            >
              <div className="h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.alt}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="300"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-[#1B2A4E] mb-1">{p.title}</h3>
                <p className="text-sm text-[#4A5568] leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}